import DriveUpHero from 'assets/images/psp/hero/drive-up-hero.webp';
import DriveUpFiveByTen from 'assets/images/unit-icons/new/5x10.svg';
import DriveUpTenByTen from 'assets/images/unit-icons/new/10x10.svg';
import DriveUpTenByFifteen from 'assets/images/unit-icons/new/10x15.svg';
import DriveUpTenByTwenty from 'assets/images/unit-icons/new/10x20.svg';
import DriveUpTenByThirty from 'assets/images/unit-icons/new/10x30.svg';
import DriveUpHeavyIcon from 'assets/images/icons/psp/furniture.svg';
import DriveUpFrequentIcon from 'assets/images/psp/amenities/box.svg';
import DriveUpMovingIcon from 'assets/images/psp/amenities/moving.svg';
import DriveUpVehicleIcon from 'assets/images/psp/amenities/24-hour.svg';
import DriveUpTimeIcon from 'assets/images/psp/amenities/time.svg';
import truckBoatCarContentSectionSVG from 'assets/images/content-section/Illustration-Truck-Boat-Car.svg';
import Featured1 from 'assets/images/psp/FeaturedImages/driveUpFeatured1.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/self1.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/driveUpFeatured3.webp';

const reviews = [
	{
		reviewTitle: 'Really easy to coordinate',
		reviewRating: 5,
		reviewText:
			'Really easy to coordinate online and to get to the unit during off-hours!',
		reviewerInitials: 'MF',

		reviewerName: 'Maegan F',
		reviewDate: 'May 13, 2025',
		link: 'https://www.trustpilot.com/users/6021c53f67997c0019b48daa',
	},
	{
		reviewTitle: 'Saved me so much time by looking…',
		reviewRating: 5,
		reviewText:
			'This was a fast and easy search to find a storage unit near me with climate control. Very easy to reserve the unit for use as well.',
		reviewerInitials: 'JW',

		reviewerName: 'Judith Talarico',
		reviewDate: 'May 10, 2025',
		link: 'https://www.trustpilot.com/reviews/681f7244c686ea854a9d70d2',
	},
	{
		reviewTitle: 'Customer service',
		reviewRating: 5,
		reviewText:
			'The SpareFoot customer service representative listened to my needs and found me the absolute perfect place within 5 minutes!',
		reviewerInitials: 'L',

		reviewerName: 'Lee',
		reviewDate: 'May 8, 2025',
		link: 'https://www.trustpilot.com/reviews/681ccbe02c79ce86945f187e',
	},
	{
		reviewTitle: 'Very, very simple to book online',
		reviewRating: 5,
		reviewText:
			'Very, very simple to book online. I called the company right after, and they had my reservation. Will definitely use them again.',
		reviewerInitials: 'DM',

		reviewerName: 'Dara Matthews',
		reviewDate: 'Apr 30, 2025',
		link: 'https://www.trustpilot.com/reviews/68111eca0f2e258317455576',
	},
];

const faqs = [
	{
		question: 'What is drive-up access storage?',
		answer: 'Drive-up storage units are ground-level units with exterior doors that let you park your vehicle directly in front, eliminating the need to carry items through hallways or use elevators.',
	},
	{
		question: 'Are drive-up storage units more expensive?',
		answer: 'Drive-up storage unit prices range from $51.47/month for a 5×10 to $165.85/month for a 10×30, comparable to interior units of similar size.',
	},
	{
		question: 'Can I store a vehicle in a drive-up storage unit?',
		answer: 'Yes, many people use drive-up storage facilities specifically for vehicle storage, including cars, motorcycles, boats, and RVs, with appropriate unit sizing.',
	},
	{
		question: 'Are drive-up units climate-controlled?',
		answer: 'Most drive-up units are not climate-controlled due to their outdoor design, but some facilities offer covered drive-up spaces with partial weather protection.',
	},
	{
		question: 'What size vehicle can access drive-up storage?',
		answer: 'Most drive-up storage facility locations accommodate standard moving trucks, but verify driveway width and turning radius for oversized vehicles or trailers.',
	},
	{
		question: 'Can I use drive-up storage for business inventory?',
		answer: 'Absolutely—drive-up access is ideal for businesses that need to frequently load and unload inventory, equipment, or supplies directly from delivery vehicles.',
	},
];

export const DriveUpContent = {
	type: 'Drive-Up',
	sections: [
		{
			title: 'Drive-Up Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'drive-up-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Drive Up Storage For You',
							image: DriveUpHero,
							description:
								'Why carry heavy boxes through winding hallways when you can park directly outside your unit? [Drive-up storage units offer ground-level access](https://www.sparefoot.com/blog/drive-up-storage-units) that lets you pull your vehicle right up to your storage door—no elevators, no long walks, no hassle. Storage units with drive-up access make loading and unloading as simple as backing up your truck. \n\n SpareFoot connects you with thousands of drive-up storage facilities, making it easy to find the perfect unit for your needs.',
							CTAText: 'Find Drive Up Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Find Drive Up Storage Near You',
					},
				},
			],
		},
		{
			title: 'What Is Drive-Up Access Storage?',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Is Drive-Up Access Storage?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Drive-up access storage refers to ground-level storage units with exterior doors that allow you to park your vehicle directly in front of your unit. Unlike interior units located inside a building, drive-up storage facility units feature roll-up doors similar to a garage, giving you direct vehicle access for loading and unloading.\n\n' +
								'### Key Features:',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'drive-up-key-features',
						headers: [
							{
								label: 'Feature',
								key: 'Feature',
							},
							{
								label: 'Description',
								key: 'Description',
							},
						],
						hideHeaders: true,
						rows: [
							{
								Feature: {
									type: 'markdown',
									markdown: '**Ground-Level Access**',
								},
								Description: 'No stairs or elevators required',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Wide Driveways**',
								},
								Description:
									'Perfect for trucks, trailers, and moving vans',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Roll-Up Doors**',
								},
								Description:
									'Easy access with vehicle-height clearance',
							},
							{
								Feature: {
									type: 'markdown',
									markdown: '**Outdoor or Covered Units**',
								},
								Description:
									'You can find standard outdoor units and covered parking-style spaces, depending on facility options',
							},
						],
					},
				},
			],
		},
		{
			title: 'Why Choose Drive-Up Access Storage?',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'unitList',
					props: {
						sectionHeader: 'Why Choose Drive-Up Access Storage?',
						slug: 'drive-up-benefits',
						headerLink: '#drive-up-benefits',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: DriveUpHeavyIcon,
								content:
									'### For Heavy or Bulky Items\n\n' +
									'[Furniture](https://www.sparefoot.com/blog/7-secrets-to-moving-large-furniture-by-yourself), appliances, and large equipment move from your vehicle directly into your unit without navigating stairs or hallways.',
								newlayout: false,
							},
							{
								image: DriveUpFrequentIcon,
								content:
									'### For Frequent Access Needs\n\n' +
									'[Business owners](https://www.sparefoot.com/blog/need-know-business-storage), contractors, and anyone who regularly visits their unit appreciate the convenience of parking right at their storage door.',
								newlayout: false,
							},
							{
								image: DriveUpMovingIcon,
								content:
									'### For Moving & Loading\n\n' +
									'Rental trucks, trailers, and moving vans can back right up to your unit, making move-in and move-out dramatically faster and easier.',
								newlayout: false,
							},
							{
								image: DriveUpVehicleIcon,
								content:
									'### For Vehicle Storage\n\n' +
									'[Drive-up storage units accommodate cars, motorcycles, boats, and RVs](https://www.sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat) with convenient pull-through access for easy parking and retrieval.',
								newlayout: false,
							},
							{
								image: DriveUpTimeIcon,
								content:
									'### For Time Savings\n\n' +
									'What might take hours with an interior unit takes minutes with drive-up access—no elevators, no carts, no wasted trips.',
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: 'Drive-Up Storage Unit Sizes & Pricing',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Drive-Up Storage Unit Sizes & Pricing',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'drive-up-storage-pricing',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: DriveUpFiveByTen,
									description:
										'[**5×10**](https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit)',
								},
								'Average Monthly Price': '$51.47',
								'What Fits':
									'Small business inventory, seasonal items, dorm room contents, motorcycle',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: DriveUpTenByTen,
									description:
										'[**10×10**](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$82.81',
								'What Fits':
									'One-bedroom apartment, office supplies, small vehicle, lawn equipment',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: DriveUpTenByFifteen,
									description:
										'[**10×15**](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Average Monthly Price': '$109.48',
								'What Fits':
									'Two-bedroom home, business equipment, small boat',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: DriveUpTenByTwenty,
									description:
										'[**10×20**](https://www.sparefoot.com/blog/10x20-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$132.43',
								'What Fits':
									'Three-bedroom house, commercial inventory, car, large boat',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: DriveUpTenByThirty,
									description:
										'[**10×30**](https://www.sparefoot.com/blog/10x30-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$165.85',
								'What Fits':
									'Four-bedroom house, vehicle fleet storage, large business inventory, RV',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'*Pricing reflects average rates for storage with drive-up access across SpareFoot.com facilities.*',
						],
					},
				},
			],
		},
		{
			title: 'Preparing Your Stuff for Drive-Up Storage',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Preparing Your Stuff for Drive-Up Storage',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: truckBoatCarContentSectionSVG,
						content: [
							'### Before You Move In:\n\n' +
								'- Measure your vehicle and items to ensure proper fit \n\n' +
								'- Use our [Storage Unit Size Calculator](https://www.sparefoot.com/storage-unit-size-guide.html) to figure out how much space you need \n\n' +
								'- Reserve a unit size with 2-3 feet of extra space for maneuvering \n\n' +
								'- Check the facility driveway width if storing oversized vehicles \n\n' +
								'- Confirm gate access hours (many drive-up storage facilities offer 24/7 access) \n\n' +
								'- Purchase heavy-duty locks designed for roll-up doors \n\n' +
								'### Loading Tips:\n\n' +
								'- Back vehicles in for easier future access \n\n' +
								'- Load your heaviest items first and distribute weight evenly \n\n' +
								'- Leave an aisle inside the unit for accessing items in the back \n\n' +
								'- Place frequently needed items near the front \n\n' +
								'- Use weatherproof covers for outdoor drive-up units',
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Drive Up Storage Search: Join Other Happy SpareFoot Customers',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Drive-Up Access Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'drive-up-featured-content',
						contentCards: [
							{
								title: 'Self Storage',
								date: 'October 27, 2025',
								image: Featured1,
								content:
									'Benefits of Drive-up Storage Units and Their Typical Uses',
								link: 'https://www.sparefoot.com/blog/drive-up-storage-units',
							},
							{
								title: 'Self Storage',
								date: 'October 22, 2025',
								image: Featured2,
								content: 'What Is Self-Storage?',
								link: 'https://www.sparefoot.com/blog/what-is-self-storage-2',
							},
							{
								title: 'Industry Trends',
								date: 'September 5, 2025',
								image: Featured3,
								content:
									'How Much Does It Cost To Rent a Storage Unit?',
								link: 'https://www.sparefoot.com/blog/how-much-does-a-storage-unit-cost',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'24Hour',
							'ClimateControl',
							'RV',
							'Boat',
							'Car',
							'Business',
							'Portable',
							'Vehicle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
	storageType: 'Drive-Up',
};
